import React, { useEffect, useState } from 'react';
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import moment from 'moment';
import PopUpTable from './PopUpTable';
import PopUpDepoTable from './PopUpDepoTable';
import PopUpDepoTable1 from './PopUpDepoTable1';
import './Trend.css'
import { getAsset } from "../../assets/assetLoader";

export default function FirstSection(props) {

    const { isLoading, error, sendReq: fetchData } = useHttp();

    // let apiprops = {};
    // apiprops.city = props.apiprops.city
    // apiprops.depo = props.apiprops.depo

    const apiprops = {
        city: props.apiprops.city,
        depo: props.apiprops.depo
    };    

    const [totalVehicleCount, setTotalVehicleCount] = useState(0);
    const [totalDrivenCount, setTotalDrivenCount] = useState(0);
    const [percentVal, setpercentVal] = useState(0);
    const [monthDropdown, setMonthDropdown] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    // const [selectedMonth, setSelectedMonth] = useState([]);
    const [convertedMonth, setConvertedMonth] = useState([]);
    const [maxDate, setMaxDate] = useState("");
    // const [selectedDepo, setSelectedDepo] = useState([]);
    // const [selectedDepo1, setSelectedDepo1] = useState([]);
    const [depoDropdown, setDepoDropdown] = useState([]);
    const [depoDropdown1, setDepoDropdown1] = useState([]);

    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedDepo, setSelectedDepo] = useState("");
    const [selectedDepo1, setSelectedDepo1] = useState("");


    const [clicked, setClicked] = useState(false);
    const [clicked1, setClicked1] = useState(false);
    const [currdate, setCurrDate] = useState("");
    const [enddate, setEndDate] = useState("");

    let currentDate = new Date(maxDate);
    let currentDayOfMonth = currentDate.getDate();
    let weekNumber = Math.ceil(currentDayOfMonth / 7);
    let startDateOfCurrentWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), (weekNumber - 1) * 7 + 1);
    let endDateOfCurrentWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), weekNumber * 7);
    let startDateOfPreviousWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), (weekNumber - 2) * 7 + 1);
    let endDateOfPreviousWeek = new Date(currentDate.getFullYear(), currentDate.getMonth(), (weekNumber - 1) * 7);

    const formattedPreviousEndDate1 = moment(endDateOfCurrentWeek).format('YYYY-MM-DD');
    const formattedPreviousStartDate1 = moment(startDateOfCurrentWeek).format('YYYY-MM-DD');

    useEffect(() => {
        setTotalVehicleCount(props.totalVehicleCount)
        fetchData(
            {
                url: API_URL_MAIN + "trend_analysis_drive_bus/getmonthRange",
                body: {
                    filterdata: {
                        "CITY": props.apiprops.city,
                        "DEPO": props.apiprops.depo,
                        "LOB": [],
                        "PL": [],
                        "PPL": [],
                        "SOC": 0,
                        "VIN_NUM": [],
                        "endDate": "",
                        "pageSelected": 1,
                        "startDate": "",
                        "AIR_VENTILATION": "",
                    }
                },
            },
            resposnceMonthCount
        );
    }, []);

    const resposnceMonthCount = (data) => {
        setMonthDropdown(data.monthdate)
        setMaxDate(data.enddate)
        setConvertedMonth(monthYearStringToDate(data.monthdate[0]));
    }

    useEffect(() => {
        if (formattedPreviousEndDate1 !== "Invalid date" && formattedPreviousStartDate1 !== "Invalid date") {
            setCurrDate(formattedPreviousEndDate1);
            setEndDate(formattedPreviousStartDate1);
            fetchData(
                {
                    url: API_URL_MAIN + "trend_analysis_drive_bus/gettotaldepo",
                    body: {
                        filterdata: {
                            "CITY": props.gloablfilter.CITY,
                            "DEPO": props.gloablfilter.DEPO,
                            "LOB": [],
                            "PL": [],
                            "PPL": [],
                            "SOC": 0,
                            "VIN_NUM": [],
                            "endDate": currdate,
                            "pageSelected": 1,
                            "startDate": enddate,
                            "AIR_VENTILATION": "",
                        }
                    },
                },
                resposnceDepoName
            );
        }

    }, [formattedPreviousEndDate1, formattedPreviousStartDate1, enddate, currdate]);

    const resposnceDepoName = (data) => {
        setDepoDropdown(data)
        setDepoDropdown1(data)
        setSelectedDepo(data[0]);
        setSelectedDepo1(data[0]);
    }

    const startdate = moment().utc().subtract(180, 'days').startOf('day').format('YYYY-MM-DD[T]00:00:00.000[Z]');
    const [selecteddate, setSelectedDate] = useState("");
    useEffect(() => {
        fetchData(
            {
                url: API_URL_MAIN + "trend_analysis_drive_bus/getdateRange",
            },
            resposnceDate
        );
    }, [props]);


    const resposnceDate = (data) => {
        setSelectedDate(data)
    }

    useEffect(() => {
        setTotalVehicleCount(props.totalVehicleCount)
        fetchData(
            {
                url: API_URL_MAIN + "trend_analysis_drive_bus/totaldrivencount",
                body: {
                    filterdata: {
                        "CITY": props.apiprops.city,
                        "DEPO": props.apiprops.depo,
                        "LOB": [],
                        "PL": [],
                        "PPL": [],
                        "SOC": 0,
                        "VIN_NUM": [],
                        "endDate": selecteddate,
                        "pageSelected": 1,
                        "startDate": selecteddate,
                        "AIR_VENTILATION": "",
                    }
                },
            },
            resposnceDrivenCount
        );
    }, [selecteddate, props]);

    const resposnceDrivenCount = (data) => {
        setTotalDrivenCount(data[0].Driven_vehicle_count.value)
    }

    useEffect(() => {
        let percentageval = (totalDrivenCount / totalVehicleCount) * 100
        setpercentVal(percentageval)
    }, [totalVehicleCount, totalDrivenCount])

    const handleMonthDetails = () => {
        setShowModal(true);
    }

    const handleClosedModal = () => {
        setShowModal(false);
    }

    const changedMonthTrigger = (data) => {
        setSelectedMonth(data);
        setConvertedMonth(monthYearStringToDate(data));
    }

    function monthYearStringToDate(monthYearString) {
        const [month, year] = monthYearString.split(' ');
        const monthIndex = new Date(Date.parse(month + ' 1, 2000')).getMonth();
        const startDate = new Date(Date.UTC(year, monthIndex, 1)).toISOString();
        const endDate = new Date(Date.UTC(year, monthIndex + 1, 0)).toISOString();
        return [startDate, endDate];
    }

    function formatDate(date) {
        let day = date.getDate();
        let month = date.toLocaleString('default', { month: 'short' });
        let year = date.getFullYear();

        let suffix = '';
        if (day === 1 || day === 21 || day === 31) {
            suffix = 'st';
        } else if (day === 2 || day === 22) {
            suffix = 'nd';
        } else if (day === 3 || day === 23) {
            suffix = 'rd';
        } else {
            suffix = 'th';
        }

        return day + suffix + ' ' + month + "'" + year;
    }

    const changedDepoTrigger1 = (data) => {
        setSelectedDepo1(data);
    }

    const handleDepoDetails1 = () => {
        setShowModal1(true);
        setClicked(true);
    }

    const handleClosedModal1 = () => {
        setShowModal1(false);
    }

    const changedDepoTrigger = (data) => {
        setSelectedDepo(data);
    }

    const handleDepoDetails = () => {
        setShowModal2(true);
        setClicked1(true);
    }

    const handleClosedModal2 = () => {
        setShowModal2(false);
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='row mt-0 pl-2 pt-0'>
                    <div className="col-md-12" style={{ paddingLeft: "6px" }}>
                        <div className="row p-2 py-3 d-flex align-items-center" style={{ border: "1px solid #ced9e9", backgroundColor: "#CDDAEA", borderRadius: "5px" }}>
                            <div className='col-md-1'>
                                <img src={getAsset("img_Bus/TrendAnalysis/arrowremovebgpreview.png")} alt='' style={{ height: "20px", width: "20px" }} />
                            </div>
                            <div className='col-md-9 mt-1 mb-1'>
                                <div className="ps-3">
                                    <p className="m-0"><small className="text-mutedf" style={{ fontWeight: "bold" }}>Lowest 5 median range buses in the last week <span style={{ fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;( {formatDate(startDateOfPreviousWeek)} to {formatDate(endDateOfPreviousWeek)} )</span><br /> for depot&nbsp;
                                        <select style={{ height: "22px", backgroundColor: "#2e75b1 ", border: "1px solid #83a3ce", borderRadius: "4px", color: "#fff", fontSize: "10px", fontWeight: "600" }}
                                            className="form-select-sm mt-1"
                                            aria-label="Default select example"
                                            onChange={(event) => changedDepoTrigger1(event.target.value)}
                                            value={selectedDepo1}
                                        >
                                            {depoDropdown1.map((month, index) => (
                                                <option style={{ marginBottom: "10px" }} key={index} value={month}>
                                                    {month}
                                                </option>
                                            ))}
                                        </select> </small></p>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <button type="submit" className="btn" onClick={handleDepoDetails1} style={{ borderRadius: "20px", height: "27px", display: "flex", backgroundColor: "#2e75b1", fontWeight: "600" }}><small style={{ color: "#fff", fontWeight: "600" }}>View</small></button>
                            </div>
                        </div>

                        <div className="row p-2 py-3 d-flex align-items-center" style={{ border: "1px solid #ced9e9", backgroundColor: "#CDDAEA", borderRadius: "5px" }}>
                            <div className='col-md-1'>
                                <img src={getAsset("img_Bus/TrendAnalysis/arrowremovebgpreview.png")} alt='' style={{ height: "20px", width: "20px" }} />
                            </div>
                            <div className='col-md-9 mt-1 mb-1'>
                                <div className="ps-3">
                                    <p className="m-0"><small className="text-mutedf" style={{ fontWeight: "bold" }}>Lowest 5 median range buses in current week <span style={{ fontWeight: "bold" }}>&nbsp;&nbsp;&nbsp;( {formatDate(startDateOfCurrentWeek)} to {formatDate(endDateOfCurrentWeek)} )</span> <br />for depot&nbsp;
                                        <select style={{ height: "22px", backgroundColor: "#2e75b1 ", border: "1px solid #83a3ce", borderRadius: "4px", color: "#fff", fontSize: "10px", fontWeight: "600" }}
                                            className="form-select-sm mt-1"
                                            aria-label="Default select example"
                                            onChange={(event) => changedDepoTrigger(event.target.value)}
                                            value={selectedDepo}
                                        >
                                            {depoDropdown.map((month, index) => (
                                                <option key={index} value={month}>
                                                    {month}
                                                </option>
                                            ))}
                                        </select> </small></p>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <button type="submit" className="btn" onClick={handleDepoDetails} style={{ borderRadius: "20px", height: "27px", display: "flex", backgroundColor: "#2e75b1 " }}><small style={{ color: "#fff", fontWeight: "600" }}>View</small></button>
                            </div>
                        </div>

                        <div className="row p-2 py-3 d-flex align-items-center" style={{ border: "1px solid #ced9e9", backgroundColor: "#CDDAEA", borderRadius: "5px" }}>
                            <div className='col-md-1'>
                                <img src={getAsset("img_Bus/TrendAnalysis/arrowremovebgpreview.png")} alt='' style={{ height: "20px", width: "20px" }} />
                            </div>
                            <div className='col-md-9 mt-2 mb-2'>
                                <div className="ps-3">
                                    <p className="m-0"><small className="text-mutedf" style={{ fontWeight: "600" }}>Lowest 5 median range buses in the month of&nbsp;
                                        <select style={{ height: "22px", backgroundColor: "#2e75b1", fontWeight: "600", border: "1px solid #83a3ce", borderRadius: "4px", color: "#fff", fontSize: "10px" }}
                                            className="form-select-sm mt-1"
                                            aria-label="Default select example"
                                            onChange={(event) => changedMonthTrigger(event.target.value)}
                                            value={selectedMonth}
                                        >
                                            {monthDropdown.map((month, index) => (
                                                <option key={index} value={month}>
                                                    {month}
                                                </option>
                                            ))}
                                        </select>
                                    </small></p>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <button type="button" className="btn" onClick={handleMonthDetails} style={{ borderRadius: "20px", height: "27px", display: "flex", backgroundColor: "#2e75b1 ", transition: "background-color 0.3s" }}><small style={{ color: "#fff", fontWeight: "600" }}>View</small></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PopUpTable show={showModal} handleClose={handleClosedModal} apiprops={apiprops} convertedMonth={convertedMonth} gloablfilter={props.gloablfilter} />
            {(clicked) ?
                <PopUpDepoTable show={showModal1} handleClose={handleClosedModal1} apiprops={apiprops} selectedDepo={selectedDepo1} startDateOfCurrentWeek={startDateOfCurrentWeek} endDateOfCurrentWeek={endDateOfCurrentWeek} startDateOfPreviousWeek={startDateOfPreviousWeek} endDateOfPreviousWeek={endDateOfPreviousWeek} />

                : <></>}

            {(clicked1) ?
                <PopUpDepoTable1 show={showModal2} handleClose={handleClosedModal2} apiprops={apiprops} selectedDepo1={selectedDepo} startDateOfCurrentWeek={startDateOfCurrentWeek} endDateOfCurrentWeek={endDateOfCurrentWeek} startDateOfPreviousWeek={startDateOfPreviousWeek} endDateOfPreviousWeek={endDateOfPreviousWeek} />
                : <></>}
        </>
    )
}
